import React, { useState } from "react";
import ModalInput from "../../ui/ModalTextInput";
import Button from "../../ui/Button";
import CustomModalContainer from "../../../components/modals/CustomModalContainer";
// import Dropdown from "../../ui/SelectDropdown";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import {
  addCourier,
  fetchAllCouriers,
} from "../../../redux/features/CourrierSlice";
import { toast } from "react-toastify";
import { courierValidationSchema } from "./schema";

interface AddCourierCompanyProps {
  open: boolean;
  onClose: () => void;
  page: number;
  limit: number;
}

const AddCourierCompany: React.FC<AddCourierCompanyProps> = ({
  open,
  onClose,
  page,
  limit,
}) => {
  const { loading } = useAppSelector((state) => state.courier);
  const dispatch = useAppDispatch();
  const [formValues, setFormValues] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    status: "ACTIVE",
  });

  const [errors, setErrors] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    status: "",
  });

  // const statusOptions = [
  //   { label: "Active", value: "ACTIVE" },
  //   { label: "Disabled", value: "DISABLED" },
  // ];

  const handleInputChange = (field: string, value: string) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleDiscard = () => {
    setFormValues({
      name: "",
      phoneNumber: "",
      email: "",
      status: "ACTIVE",
    });
    setErrors({
      name: "",
      phoneNumber: "",
      email: "",
      status: "",
    });
    onClose();
  };

  const handleValidation = async () => {
    try {
      await courierValidationSchema.validate(formValues, { abortEarly: false });
      setErrors({
        name: "",
        phoneNumber: "",
        email: "",
        status: "",
      });
      return true;
    } catch (err: any) {
      const newErrors: any = {};
      err.inner.forEach((error: any) => {
        newErrors[error.path] = error.message;
      });
      setErrors(newErrors);
      return false;
    }
  };

  const handleSubmit = async () => {
    const isValid = await handleValidation();
    if (isValid) {
      dispatch(addCourier(formValues))
        .unwrap()
        .then(() => {
          toast.success("Courier added successfully");
          dispatch(fetchAllCouriers({ page, limit }));
          handleDiscard();
        })
        .catch((error) => {
          console.error("Failed to add courier:", error);
          // Handle error (e.g., show a toast message or error notification)
        });
    }
  };

  if (!open) return null;

  return (
    <CustomModalContainer
      title="Add Courier Company"
      footer={
        <div className="flex justify-between relative bottom-0">
          <Button
            type="button"
            onClick={handleDiscard}
            label="Discard"
            customStyle={{
              width: "auto",
              minWidth: "150px",
              background: "none",
              color: "#000",
            }}
          />
          <Button
            label="Done"
            type="button"
            onClick={handleSubmit}
            customStyle={{
              width: "auto",
              minWidth: "150px",
            }}
            isLoading={loading}
          />
        </div>
      }
      open={open}
      onClose={onClose}
    >
      <div className="p-6">
        <ModalInput
          label="Company Name"
          placeholder="Enter company name"
          value={formValues.name}
          onChange={(e) => handleInputChange("name", e.target.value)}
          error={errors.name}
          required
        />
        <ModalInput
          label="Phone Number"
          placeholder="Enter phone number"
          value={formValues.phoneNumber}
          onChange={(e) => handleInputChange("phoneNumber", e.target.value)}
          error={errors.phoneNumber}
          required
        />
        <ModalInput
          label="Email Address"
          type="email"
          placeholder="Enter email address"
          value={formValues.email}
          onChange={(e) => handleInputChange("email", e.target.value)}
          error={errors.email}
          required
        />
        {/* <Dropdown
          label="Status"
          options={statusOptions}
          value={formValues.status}
          onSelect={(value) => handleInputChange("status", value)}
          error={errors.status}
          required
        /> */}
      </div>
    </CustomModalContainer>
  );
};

export default AddCourierCompany;
